import {withStyles} from '@material-ui/core';
import MuiSlider from '@material-ui/core/Slider';

const MixerSlider = withStyles(() => ({
    root: {
        color: '#fff',
        height: 2,
    },
    thumb: {
        height: 20,
        width: 20,
        backgroundColor: "rgba(0,0,0,0)",
        boxShadow: "none",
        marginTop: 5,
        marginLeft: -10,
        '&:focus, &:hover, &$active': {
            boxShadow: "none",
        },
    },
    active: {},
    track: {
        height: 2,
    },
    rail: {
        height: 2,
    },
}))(MuiSlider);

export default MixerSlider;